import { reportConstants } from '../constants'


const initialState = {
    leadAndSaleOpportunity: {
        loading: false,
        error: null,
        list: []
    },
    manager: {
        loading: false,
        error: null,
        data: null,
    }
}

export function report(state = initialState, action) {
    switch (action.type) {
        case reportConstants.GET_LEAD_AND_SALE_OPPORTUNITY_REPORT_REQUEST:
            return {
                ...state,
                leadAndSaleOpportunity: {
                    ...state.leadAndSaleOpportunity,
                    loading: true,
                }
            }
        case reportConstants.GET_LEAD_AND_SALE_OPPORTUNITY_REPORT_SUCCESS:
            return {
                ...state,
                leadAndSaleOpportunity: {
                    ...state.leadAndSaleOpportunity,
                    loading: false,
                    list: action.data
                }
            }
        case reportConstants.GET_LEAD_AND_SALE_OPPORTUNITY_REPORT_FAILURE:
            return {
                ...state,
                leadAndSaleOpportunity: {
                    ...state.leadAndSaleOpportunity,
                    loading: false,
                    error: action.error
                }
            }
        case reportConstants.GET_MANAGER_REPORT_REQUEST:
            return {
                ...state,
                manager: {
                    ...state.manager,
                    loading: true,
                    error: null,
                }
            }
        case reportConstants.GET_MANAGER_REPORT_SUCCESS:
            return {
                ...state,
                manager: {
                    loading: false,
                    error: null,
                    data: action.data,
                }
            }
        case reportConstants.GET_MANAGER_REPORT_FAILURE:
            return {
                ...state,
                manager: {
                    ...state.manager,
                    loading: false,
                    error: action.error,
                }
            }
        default:
            return state
    }
}
